import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import AdminDashboard from './Pages/Admin/AdminDashboard/AdminDashboard';
import ResellerDashboard from './Pages/Admin/ResellerDashboard/ResellerDashboard';
import BuyCredits from './Pages/Admin/BuyCredits/BuyCredits';
// import ShowUser from './Pages/Admin/ShowUser/ShowUser';
import AddLicense from './Pages/Admin/Licenses/Add';
import IndexLicenses from './Pages/Admin/Licenses/index';
// import CompletedPayments from './Pages/Admin/CompletedPayments/CompletedPayments';
// import GeneratedPayments from './Pages/Admin/GeneratedPayments/GeneratedPayments';
import SendEmail from './Pages/Admin/SendEmail/SendEmail';
import NotFound from './Pages/Public/NotFound/NotFound';
import { AdminRoute } from './authentication/AdminRoutes';
import { ResellerRoute } from './authentication/ResellerRoute';
import { GuestRoute } from './authentication/GuestRoute';
// import ProductReleaseNotes from './Pages/Admin/ProductReleaseNotes/ProductReleaseNotes';
// import SPCADFeatures from './Pages/Public/Products/SPCAD/SPCADFeatures';

import TrialLicenses from './Pages/Admin/TrialLicenses/index';
import CommandLogs from './Pages/Admin/CommandLogs/index';
// import ShowUserTrial from './Pages/Admin/ShowUserTrial/ShowUserTrial';
import ShowUserTrial from './Pages/Admin/TrialLicenses/show';

import Signin from './Pages/User/Auth/Signin/Sigin';
import UserDashboard from './Pages/User/UserDashboard/UserDashboard';
import Signup from './Pages/User/Auth/Signup/Signup';
import VerifyEmail from './Pages/User/VerifyEmail/VerifyEmail';
import Profile from './Pages/User/Profile/Profile';
import ForgotPasswordRequest from './Pages/User/Auth/ForgotPassword/ForgotPasswordRequest';
import ChangePassword from './Pages/User/Auth/ForgotPassword/ChangePassword';
import Licenses from './Pages/User/Licenses/Licenses';
import { UserRoute } from './authentication/UserRoute';
import { AuthedRoute } from './authentication/AuthedRoute';
import AttachedMachines from './Pages/User/AttachedMachines/AttachedMachines';
import BuyLicense from './Pages/User/BuyLicense/BuyLicense';
import GenerateOrder from './Pages/User/GenerateOrder/GenerateOrder';
import Orders from './Pages/User/Orders/Orders';
import AdminSignin from './Pages/Admin/Auth/Signin/AdminSignin';
import RequestQuote from './Pages/User/RequestQuote/RequestQuote';
import RequestQuotes from './Pages/Admin/RequestedQuotes/RequestedQuotes';
import AssignedMachines from './Pages/Admin/Licenses/AssignedMachines';
import Invoice from './Pages/Admin/Licenses/Invoice';
import EditLicense from './Pages/Admin/Licenses/Edit';
import EditUser from './Pages/Admin/Users/edit';
import UsersIndex from './Pages/Admin/Users/index';
import CreateUser from './Pages/Admin/Users/create';
import UserShow from './Pages/Admin/Users/show';
import TrialVerificationCodes from './Pages/Admin/VerificationCodes/TrialVerificationCodes';
import LicenseVerificationCodes from './Pages/Admin/VerificationCodes/LicenseVerificationCode';
import PostPaymentPaymob from './Pages/Public/PostPaymentPaymob/postPaymentPaymob';
import IndexCoupon from './Pages/Admin/Coupons';
import EditCoupon from './Pages/Admin/Coupons/edit';
import CreateCoupon from './Pages/Admin/Coupons/create';
import IndexProducts from './Pages/Admin/Products';
import CreateProducts from './Pages/Admin/Products/create';
import EditProducts from './Pages/Admin/Products/edit';
import CompletedIndex from './Pages/Admin/Orders/CompletedOrders';
import GeneratedIndex from './Pages/Admin/Orders/GeneratedOrders';
import IndexUserProfiles from './Pages/Admin/UserProfiles';
import EditUserProfiles from './Pages/Admin/UserProfiles/edit';
import CreateUserProfiles from './Pages/Admin/UserProfiles/create';
import IndexDocument from './Pages/Admin/Document';
import EditDocument from './Pages/Admin/Document/edit';
import CreateDocument from './Pages/Admin/Document/create';
import ViewDocument from './Pages/Admin/Document/viewDocument';
import ActiveServices from './Pages/Admin/Services';
import ADDService from './Pages/Admin/Services/create';
import EditService from './Pages/Admin/Services/edit';
import HelpAndSupport from './Pages/User/UserDashboard/Help';
import TagsIndex from './Pages/Admin/Tags/index';
import ResellersList from './Pages/Admin/Resellers/index';
import ResellerDetail from './Pages/Admin/Resellers/detail';
import RolesIndex from './Pages/Admin/Roles/index';

function App() {
  return (
    <Router>
      <Toaster />
      <Routes>
        <Route path="/" element={<UserRoute><UserDashboard /></UserRoute>} exact />

        <Route path="/Signin" element={<GuestRoute><Signin /></GuestRoute>} exact />
        <Route path="/Signup" element={<GuestRoute><Signup /></GuestRoute>} exact />
        {/* Email confirmation is a portal page, not an auth screen — signup
            signs the user in first, so they always reach it logged in. The old
            signed-out URLs are kept as redirects for anything still linking to
            them; UserRoute sends a signed-out visitor to /signin, which an
            unverified account can now get through. */}
        <Route path="/VerifyEmail/:email" element={<Navigate to="/User/VerifyEmail" replace />} exact />
        <Route path="/VerifyEmail" element={<Navigate to="/User/VerifyEmail" replace />} exact />
        <Route path="/ForgotPasswordRequest" element={<GuestRoute><ForgotPasswordRequest /></GuestRoute>} exact />
        <Route path="/ChangePassword/:email" element={<GuestRoute><ChangePassword /></GuestRoute>} exact />
        <Route path="/postpayment" element={<PostPaymentPaymob />} exact />

        {/* "My account" belongs to the person, not to a dashboard, so it sits
            outside the /User, /Admin and /Reseller trees and admits all three
            portals — each reaches it from its own profile dropdown. The old
            /User/Profile URL redirects here for anything still linking to it. */}
        <Route path="/Profile" element={<AuthedRoute><Profile /></AuthedRoute>} exact />

        <Route path="/User/Dashboard" element={<UserRoute><UserDashboard /></UserRoute>} exact />
        <Route path="/User/licenses" element={<UserRoute><Licenses /></UserRoute>} exact />
        <Route path="/User/licenses/:license_id" element={<UserRoute><AttachedMachines /></UserRoute>} exact />
        {/* <Route  path="/User/BuyLicense" element={<UserRoute><BuyLicense/></UserRoute>} exact/> */}
        {/* <Route  path="/User/BuyLicense/GenerateOrder/:product_id" element={<UserRoute><GenerateOrder/></UserRoute>} exact/> */}
        <Route path="/User/Orders" element={<UserRoute><Orders /></UserRoute>} exact />
        <Route path="/User/RequestQuote" element={<UserRoute><RequestQuote /></UserRoute>} exact />
        <Route path="/User/Help" element={<UserRoute><HelpAndSupport /></UserRoute>} exact />
        <Route path="/User/VerifyEmail" element={<UserRoute><VerifyEmail /></UserRoute>} exact />
        <Route path="/User/Profile" element={<Navigate to="/Profile" replace />} exact />

        <Route path="/Admin/Dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} exact />
        <Route path="/Admin/ResellerDashboard" element={<ResellerRoute><ResellerDashboard /></ResellerRoute>} exact />
        <Route path="/Admin/BuyCredits" element={<AdminRoute portals={["reseller"]} permission="reseller.credits.request"><BuyCredits /></AdminRoute>} exact />
        {/*         
        <Route  path="/Admin/ShowUser/:TargetSecurityKey" element={<AdminRoute><ShowUser/></AdminRoute>} exact/>
        <Route  path="/Admin/CompletedPayments" element={<AdminRoute><CompletedPayments/></AdminRoute>} exact/>
        <Route  path="/Admin/GeneratedPayments" element={<AdminRoute><GeneratedPayments/></AdminRoute>} exact/>
        <Route  path="/Admin/ProductReleaseNotes" element={<AdminRoute><ProductReleaseNotes/></AdminRoute>} exact/> 
        */}
        <Route path="/Admin/Licenses/Add" element={<AdminRoute permission="admin.licenses.create"><AddLicense /></AdminRoute>} exact />
        <Route path="/Admin/Licenses" element={<AdminRoute portals={["admin", "reseller"]} permission={["admin.licenses.index", "reseller.licenses.index"]}><IndexLicenses /></AdminRoute>} exact />
        <Route path="/Admin/Licenses/:id/AssignedMachines" element={<AdminRoute permission="admin.licenses.assigned_machines"><AssignedMachines /></AdminRoute>} exact />
        <Route path="/Admin/Licenses/:id/edit" element={<AdminRoute permission="admin.licenses.update"><EditLicense /></AdminRoute>} exact />

        <Route path="Admin/triallicenses" element={<AdminRoute permission="admin.trial_licenses.index"><TrialLicenses /></AdminRoute>} exact />
        <Route path="/Admin/triallicenses/edit/:TargetSecurityKey" element={<AdminRoute permission="admin.trial_licenses.show"><ShowUserTrial /></AdminRoute>} exact />

        <Route path="/Admin/SendEmail" element={<AdminRoute permission="admin.marketing.emails"><SendEmail /></AdminRoute>} exact />
        <Route path="/Admin/Quotes" element={<AdminRoute permission="admin.marketing.quotes_index"><RequestQuotes /></AdminRoute>} exact />

        <Route path="/Admin/Products" element={<AdminRoute permission="admin.products.index"><IndexProducts /></AdminRoute>} exact />
        <Route path="/Admin/Products/Add" element={<AdminRoute permission="admin.products.create"><CreateProducts /></AdminRoute>} exact />
        <Route path="/Admin/Products/edit/:id" element={<AdminRoute permission="admin.products.update"><EditProducts /></AdminRoute>} exact />

        <Route path="/Admin/Services" element={<AdminRoute permission="admin.services.index"><ActiveServices /></AdminRoute>} exact />
        <Route path="/Admin/Services/new" element={<AdminRoute permission="admin.services.create"><ADDService /></AdminRoute>} exact />
        <Route path="/Admin/Services/edit/:id" element={<AdminRoute permission="admin.services.update"><EditService /></AdminRoute>} exact />

        <Route path="/Admin/Licenses/Invoice/:id" element={<AdminRoute permission="admin.users.invoice"><Invoice /></AdminRoute>} exact />

        <Route path="/Admin/Users" element={<AdminRoute portals={["admin", "reseller"]} permission={["admin.users.index", "reseller.users.index"]}><UsersIndex /></AdminRoute>} exact />
        <Route path="/Admin/Users/Add" element={<AdminRoute permission="admin.users.create"><CreateUser /></AdminRoute>} exact />
        <Route path="/Admin/Users/:id/edit" element={<AdminRoute permission="admin.users.update"><EditUser /></AdminRoute>} exact />
        <Route path="/Admin/Users/:id" element={<AdminRoute portals={["admin", "reseller"]} permission={["admin.users.invoice", "reseller.users.show"]}><UserShow /></AdminRoute>} exact />

        <Route path="/Admin/Coupons" element={<AdminRoute permission="admin.coupons.index"><IndexCoupon /></AdminRoute>} exact />
        <Route path="/Admin/Coupons/:id/edit" element={<AdminRoute permission="admin.coupons.update"><EditCoupon /></AdminRoute>} exact />
        <Route path="/Admin/Coupons/new" element={<AdminRoute permission="admin.coupons.create"><CreateCoupon /></AdminRoute>} exact />

        <Route path="/Admin/UserProfiles" element={<AdminRoute permission="admin.user_profiles.index"><IndexUserProfiles /></AdminRoute>} exact />
        <Route path="/Admin/UserProfiles/:id/edit" element={<AdminRoute permission="admin.user_profiles.update"><EditUserProfiles /></AdminRoute>} exact />
        <Route path="/Admin/UserProfiles/new" element={<AdminRoute permission="admin.user_profiles.create"><CreateUserProfiles /></AdminRoute>} exact />

        <Route path="/Admin/Documents" element={<AdminRoute permission="admin.documents.index"><IndexDocument /></AdminRoute>} exact />
        <Route path="/Admin/Documents/:id/edit" element={<AdminRoute permission="admin.documents.update"><EditDocument /></AdminRoute>} exact />
        <Route path="/Admin/Documents/new" element={<AdminRoute permission="admin.documents.create"><CreateDocument /></AdminRoute>} exact />
        <Route path="/Admin/Documents/:id" element={<AdminRoute permission="admin.documents.show"><ViewDocument /></AdminRoute>} exact />

        <Route path="/Admin/TrialVerificationCodes/" element={<AdminRoute permission="admin.verification_codes.trial_index"><TrialVerificationCodes /></AdminRoute>} exact />
        <Route path="/Admin/LicenseVerificationCodes/" element={<AdminRoute permission="admin.verification_codes.license_index"><LicenseVerificationCodes /></AdminRoute>} exact />

        <Route path="/Admin/Orders/completed" element={<AdminRoute permission="admin.orders.completed"><CompletedIndex /></AdminRoute>} exact />
        <Route path="/Admin/Order/generated" element={<AdminRoute permission="admin.orders.generated"><GeneratedIndex /></AdminRoute>} exact />

        {/* <Route  path="/Admin/GeneratedOrders/" element={<AdminRoute><GeneratedOrders/></AdminRoute>} exact/>
        <Route  path="/Admin/CompletedOrders/" element={<AdminRoute><CompletedOrders/></AdminRoute>} exact/> */}

        <Route path="/Admin/Resellers" element={<AdminRoute permission="admin.resellers.index"><ResellersList /></AdminRoute>} exact />
        <Route path="/Admin/Resellers/:id" element={<AdminRoute permission="admin.resellers.show"><ResellerDetail /></AdminRoute>} exact />

        <Route path="/Admin/Tags" element={<AdminRoute permission="admin.tags.index"><TagsIndex /></AdminRoute>} exact />
        <Route path="/Admin/Roles" element={<AdminRoute permission="admin.roles.index"><RolesIndex /></AdminRoute>} exact />

        <Route path="/Admin/CommandLogs" element={<AdminRoute permission="admin.command_logs.index"><CommandLogs /></AdminRoute>} exact />

        {/* Keep the catch-all last: react-router picks the best match rather than
            the first, but ordering it last keeps the intent obvious. */}
        <Route path='*' element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;

